import { withMotionMax } from '@hoc/withMotionMax';
import PeopleCard from '@stories/Components/Cards/PeopleCard/PeopleCard';
import CarouselProvider from '@stories/Components/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '@stories/Components/Carousels/Carousel/Pagination/Pagination';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './PeopleListing.styles';
const PeopleListing = (props) => {
    return (React.createElement(MotionConfig, { transition: { duration: 0.35, ease: 'easeOut' } },
        React.createElement(CarouselProvider, { paddingOffset: 0, count: props.items.length },
            React.createElement(S.Container, { id: props.anchorId, "data-type": props.type },
                React.createElement(S.Title, { ...(props.titleType && props.titleType === 'h1' ? { as: 'h1' } : {}) }, props.title),
                React.createElement(S.CarouselWrapper, null,
                    React.createElement(S.Track, { enableCarousel: props.type === 'carousel' }, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                        React.createElement(PeopleCard, { ...item })))))),
                React.createElement(S.ControlsWrapper, null,
                    React.createElement(Pagination, null))))));
};
export default withMotionMax(PeopleListing);
